import {
  INQUIRY_DETAIL,
  INQUIRY_DETAIL_ERROR,
  INQUIRY_DETAIL_LOADING,
  INQUIRY_QUOTATION_ERROR,
  INQUIRY_QUOTATION_LOADING,
  INQUIRY_ERROR,
  INQUIRY_LIST,
  INQUIRY_LOADING,
  SECTOR_LIST,
  SECTOR_LOADING,
  SECTOR_ERROR,
  PRODUCT_LIST,
  PRODUCT_REQUEST,
  PRODUCT_LOADING,
  PRODUCT_ERROR,
} from "../actions/type";

const initialState = {
  items: [],
  detail: null,
  detailLoading: false,
  detailError: "",
  quotationLoading: false,
  quotationError: "",
  pagination: {
    page: 1,
    limit: 10,
    total: 0,
    totalPages: 1,
  },
  loading: false,
  error: "",
  sectors: [],
  sectorsLoading: false,
  sectorsError: "",
  products: [],
  productRequestId: 0,
  productsSector: "",
  productsLoading: false,
  productsError: "",
};

export default function inquiry(state = initialState, action) {
  switch (action.type) {
    case INQUIRY_LIST:
      return { ...state, ...action.payload };
    case INQUIRY_DETAIL:
      return { ...state, detail: action.payload };
    case INQUIRY_DETAIL_LOADING:
      return { ...state, detailLoading: action.payload };
    case INQUIRY_DETAIL_ERROR:
      return { ...state, detailError: action.payload };
    case INQUIRY_QUOTATION_LOADING:
      return { ...state, quotationLoading: action.payload };
    case INQUIRY_QUOTATION_ERROR:
      return { ...state, quotationError: action.payload };
    case INQUIRY_LOADING:
      return { ...state, loading: action.payload };
    case INQUIRY_ERROR:
      return { ...state, error: action.payload };
    case SECTOR_LIST:
      return { ...state, sectors: action.payload };
    case SECTOR_LOADING:
      return { ...state, sectorsLoading: action.payload };
    case SECTOR_ERROR:
      return { ...state, sectorsError: action.payload };
    case PRODUCT_LIST:
      return { ...state, products: action.payload };
    case PRODUCT_REQUEST:
      return {
        ...state,
        productRequestId: action.payload.requestId,
        productsSector: action.payload.sector,
      };
    case PRODUCT_LOADING:
      return { ...state, productsLoading: action.payload };
    case PRODUCT_ERROR:
      return { ...state, productsError: action.payload };
    default:
      return state;
  }
}
